<template>
  <div>
    <div v-for="(item, index) of musicSrc" :key="index">
      <iframe
        frameborder="no" border="0" marginwidth="0" marginheight="0" width=280 height=86
        :src="item"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeMusic',
  data () {
    return {
      musicSrc: [],
      music: [
        {
          type: 2,
          id: 183055,
          auto: 0,
          height: 66
        }, {
          type: 2,
          id: 255299,
          auto: 0,
          height: 66
        }, {
          type: 3,
          id: 2064170528,
          auto: 0,
          height: 66
        }
      ]
    }
  },
  mounted () {
    for (let item of this.music) {
      this.musicSrc.push('//music.163.com/outchain/player?' +
        'type=' + item.type +
        '&id=' + item.id +
        '&auto=' + item.auto +
        '&height=' + item.height)
    }
    console.log(this.musicSrc)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Home/components/Music.vue